import React, { useEffect, useState } from "react";
import { Outlet, Link } from "react-router-dom";
import Nav from "../../../components/Nav";
import SideNavItem from "../../../components/SideNavItem";
import { useDispatch, useSelector } from "react-redux";
import { fetchProfilePhoto } from "../../../store/AthleteActions";
import { useAxiosInstance } from "../../../services/Interceptor";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGauge, faTrophy, faUser } from "@fortawesome/free-solid-svg-icons";
import { getHighSchoolProfile } from "../../../services/HighSchoolService";

function HighSchoolLayout() {
  const dispatch = useDispatch();
  const apiInstance = useAxiosInstance();
  const authUser = useAuthUser();
  const { profilePhoto } = useSelector((state) => state.athletes);

  const [profilePicture, setProfilePicture] = useState(null);
  const [highSchoolProfileData, setHighSchoolProfileData] = useState(null);

  useEffect(() => {
    if (authUser?.user?.role === "highschool" && authUser?.user?.id) {
      dispatch(fetchProfilePhoto(apiInstance, authUser.user.id));
    }
  }, [dispatch, apiInstance, authUser?.user?.role, authUser?.user?.id]);

  useEffect(() => {
    const fetchHighSchoolProfile = async () => {
      try {
        const response = await getHighSchoolProfile(apiInstance);
        setHighSchoolProfileData(response);
      } catch (error) {
        console.error("Failed to fetch high school profile", error);
      }
    };

    if (authUser?.user?.role?.toLowerCase?.() === "highschool") {
      fetchHighSchoolProfile();
    }
  }, [apiInstance, authUser?.user?.role]);

  useEffect(() => {
    if (profilePhoto) {
      setProfilePicture(profilePhoto);
    }
  }, [profilePhoto]);

  return (
    authUser && (
      <>
        <div className="h-screen flex flex-col">
          <div className="px-0 md:px-4 bg-[#363636]">
            <Nav />
          </div>
          <div className="flex flex-row h-full">
            <div className="w-[300px] bg-[#545353] flex-col h-full hidden sm:hidden md:hidden lg:hidden xl:block">
              <div className="w-[300px]">
                <div className="w-[100px] h-[105px] min-h-[100px] mx-auto mt-8 border-2 rounded-md border-gray-500 overflow-hidden">
                  <img
                    src={profilePicture?.fileUrl || "/default-profile-img.png"}
                    alt="profile"
                    className="object-cover h-full w-full"
                  />
                </div>
              </div>
              <p className="text-red-500 uppercase text-center text-xl mt-4 font-light">
                {authUser?.user?.firstName} {authUser?.user?.lastName}
              </p>
              <p className="text-white font-medium uppercase text-center text-base mt-1">
                {highSchoolProfileData?.club ||
                  highSchoolProfileData?.highSchool ||
                  authUser?.user?.highSchool}
              </p>
              <hr className="w-4/5 mx-auto mt-4" />
              <div className="flex flex-col">
                <SideNavItem
                  route={"/highschool/dashboard"}
                  displayText={"Dashboard"}
                />
                <SideNavItem
                  route={"/highschool/leaderboard"}
                  displayText={"Leaderboard"}
                />
                <SideNavItem
                  route={"/highschool/account"}
                  displayText={"Account"}
                />
              </div>
            </div>
            <div className="flex-grow">
              <Outlet />
            </div>
          </div>
        </div>

        <div className="fixed bottom-0 left-0 z-40 w-full h-18 bg-[#545353] block sm:block lg:block md:block xl:hidden">
          <div className="grid h-full w-full grid-cols-3 mx-auto font-medium justify-items-center">
            <Link to="/highschool/dashboard" className="">
              <button
                type="button"
                className="inline-flex flex-col items-center justify-center px-4 pt-4 pb-5 group hover:border-t-4 hover:border-red-500 selection:text-red-500"
              >
                <FontAwesomeIcon
                  icon={faGauge}
                  className="w-5 h-5 mb-2 text-gray-50 group-hover:text-red-500"
                />
                <span className="text-sm text-gray-50 group-hover:text-red-500">
                  Dashboard
                </span>
              </button>
            </Link>
            <Link to="/highschool/leaderboard">
              <button
                type="button"
                className="inline-flex flex-col items-center justify-center px-4 pt-4 pb-5 group hover:border-t-4 hover:border-red-500 selection:text-red-500"
              >
                <FontAwesomeIcon
                  icon={faTrophy}
                  className="w-5 h-5 mb-2 text-gray-50 group-hover:text-red-500"
                />
                <span className="text-sm text-gray-50 group-hover:text-red-500">
                  Leaderboard
                </span>
              </button>
            </Link>
            <Link to="/highschool/account">
              <button
                type="button"
                className="inline-flex flex-col items-center justify-center px-4 pt-4 pb-5 group hover:border-t-4 hover:border-red-500 selection:text-red-500"
              >
                <FontAwesomeIcon
                  icon={faUser}
                  className="w-5 h-5 mb-2 text-gray-50 group-hover:text-red-500"
                />
                <span className="text-sm text-gray-50 group-hover:text-red-500">
                  Account
                </span>
              </button>
            </Link>
          </div>
        </div>
      </>
    )
  );
}

export default HighSchoolLayout;
